export const QUESTION_MULTIPLE_CHOICE = 'Scelta multipla';
export const QUESTION_OPEN_FILL = 'Completamento aperto';
export const QUESTION_CLOSE_FILL = 'Completamento chiuso';
export const QUESTION_POSITIONING = 'Posizionamento';
export const QUESTION_FIND_ERROR = 'Trova errore';
export const QUESTION_TRUE_FALSE = 'Vero o falso';
export const QUESTION_SEQUENCE = 'Associa';
export const QUESTION_CHECKER = 'Checker';
export const QUESTION_OPEN_QUESTION = 'Risposta aperta';
export const SHAREDTEXT = 'Testo condiviso';

export const NAME_MULTIPLE_CHOICE = 'exercise.multiplechoice';
export const NAME_OPEN_FILL = 'exercise.opengap';
export const NAME_CLOSE_FILL = 'exercise.closedgap';
export const NAME_POSITIONING = 'exercise.dragndrop';
export const NAME_FIND_ERROR = 'exercise.finderror';
export const NAME_TRUE_FALSE = 'exercise.truefalse';
export const NAME_SEQUENCE = 'exercise.barrage';
export const NAME_CHECKER = 'exercise.checker';
export const NAME_OPEN_QUESTION = 'exercise.openanswer';

export const ID_QUESTION_MULTIPLE_CHOICE = 1;
export const ID_QUESTION_OPEN_FILL = 2;
export const ID_QUESTION_CLOSE_FILL = 3;
export const ID_QUESTION_POSITIONING = 4;
export const ID_QUESTION_FIND_ERROR = 5;
export const ID_QUESTION_TRUE_FALSE = 6;
export const ID_QUESTION_SEQUENCE = 7;
export const ID_QUESTION_CHECKER = 8;
export const ID_QUESTION_OPEN_QUESTION = 9;
export const ID_SHAREDTEXT = 10;

export const FILL_QUESTION_TYPE_TEXT = 'FILL_QUESTION_TYPE_TEXT';
export const FILL_QUESTION_TYPE_CHOICE = 'FILL_QUESTION_TYPE_CHOICE';

export const ExerciseTypes = [
    { id: ID_QUESTION_MULTIPLE_CHOICE, name: NAME_MULTIPLE_CHOICE },
    { id: ID_QUESTION_OPEN_FILL, name: NAME_OPEN_FILL },
    { id: ID_QUESTION_CLOSE_FILL, name: NAME_CLOSE_FILL },
    { id: ID_QUESTION_POSITIONING, name: NAME_POSITIONING },
    { id: ID_QUESTION_FIND_ERROR, name: NAME_FIND_ERROR },
    { id: ID_QUESTION_TRUE_FALSE, name: NAME_TRUE_FALSE },
    { id: ID_QUESTION_SEQUENCE, name: NAME_SEQUENCE },
    { id: ID_QUESTION_CHECKER, name: NAME_CHECKER },
    { id: ID_QUESTION_OPEN_QUESTION, name: NAME_OPEN_QUESTION }
];
